import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

declare let hbspt: any;

@Component({
  selector: 'cai-cargomart-plan-selector-modal',
  templateUrl: './cargomart-plan-selector-modal.component.html',
  styleUrls: ['./cargomart-plan-selector-modal.component.scss'],
  standalone: false,
})
export class CargoMartPlanSelectorModal {
  @Input() isEurope: boolean = false;

  features = {
    free: [
      $localize`:@@office-setting.live-capacity-rates-bookings:Live Capacity, rates & bookings with 100+ airlines`,
      $localize`:@@office-setting.40-exclusive-airlines:40+ exclusive airline`,
      $localize`:@@office-setting.allotment-bookings:Allotment bookings`,
      $localize`:@@office-setting.spot-rates-on-600-airlines:Spot rates on 600+ airlines`,
      $localize`:@@office-setting.automatic-awb-assignment:Automatic AWB assignment`,
      $localize`:@@office-setting.user-notification-management:User notification management`,
      $localize`:@@office-setting.in-app-support:In-App support`,
    ],
    pro: [
      $localize`:@@office-setting.booking-options:Booking options`,
      $localize`:@@office-setting.airline-quality-score:Airline Quality Score`,
      $localize`:@@office-setting.rate-management-module:Rate Management module`,
      $localize`:@@office-setting.cargocopilot-ai-rate-insight:CargoCOPILOT AI rate insight`,
      $localize`:@@office-setting.multi-office-access:Multi-office access`,
      $localize`:@@office-setting.roles-and-permissions-management:Roles & permissions management`,
      $localize`:@@office-setting.cargobroker-network:CargoBROKER network`,
      $localize`:@@office-setting.cargo2zero-solutions:Cargo2ZERO solutions`,
    ],
    inProduct: [
      $localize`:@@office-setting.cargointel-analytics-solution:CargoINTEL analytics solution  $99/month`,
    ],
    addons: [
      $localize`:@@office-setting.cargocopilot-email-plugin:CargoCOPILOT email plug-in`,
      $localize`:@@office-setting.co2-emission-report:CO2 emission customized report`,
      $localize`:@@office-setting.single-signon-sso-login:Single Sign-On (SSO) Login`,
      $localize`:@@office-setting.skypallet-3d-visualization:Skypallet 3D vizualisation`,
      $localize`:@@office-setting.priority-onboarding-training:Priority onboarding & training`,
    ],
  };
  showContactForm = false;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  get headerMessage(): string {
    if (this.showContactForm) {
      return $localize`:@@office-setting.request-add-ons:REQUEST ADD-ONS`;
    }
    return $localize`:@@office-setting.choose-plan-right-for-you:CHOOSE A PLAN THAT'S RIGHT FOR YOU`;
  }

  closeModal(result?: string) {
    if (result) {
      this.activeModal.close(result);
    } else {
      this.activeModal.dismiss();
    }
  }

  openContactForm() {
    hbspt.forms.create({
      region: 'na1',
      portalId: '7989695',
      formId: '05951f22-adb4-43f9-9b52-2e8d1747776b',
      target: '#addonContactForm',
    });
    this.showContactForm = true;
    this.cdr.detectChanges();
  }

  protected get currencySymbol(): string {
    return this.isEurope ? '€' : '$';
  }
}
